/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebsiteOnPageRequestsWhitelistRulesQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type WebsiteOnPageRequestsWhitelistRulesQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly adminSettings: { readonly __typename?: 'WebsiteAdminSettings', readonly onPageRequestsWhitelistRules: ReadonlyArray<{ readonly __typename?: 'OnPageRequestsBlockingRule', readonly operator: GraphQL.OnPageRequestsBlockingRuleOperator, readonly value: string }> } | null } | null };


export const WebsiteOnPageRequestsWhitelistRulesDocument = gql`
    query WebsiteOnPageRequestsWhitelistRules($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    adminSettings {
      onPageRequestsWhitelistRules {
        operator
        value
      }
    }
    id
  }
}
    `;

/**
 * __useWebsiteOnPageRequestsWhitelistRulesQuery__
 *
 * To run a query within a React component, call `useWebsiteOnPageRequestsWhitelistRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteOnPageRequestsWhitelistRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteOnPageRequestsWhitelistRulesQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteOnPageRequestsWhitelistRulesQuery(baseOptions: Apollo.QueryHookOptions<WebsiteOnPageRequestsWhitelistRulesQuery, WebsiteOnPageRequestsWhitelistRulesQueryVariables> & ({ variables: WebsiteOnPageRequestsWhitelistRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteOnPageRequestsWhitelistRulesQuery, WebsiteOnPageRequestsWhitelistRulesQueryVariables>(WebsiteOnPageRequestsWhitelistRulesDocument, options);
      }
export function useWebsiteOnPageRequestsWhitelistRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteOnPageRequestsWhitelistRulesQuery, WebsiteOnPageRequestsWhitelistRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteOnPageRequestsWhitelistRulesQuery, WebsiteOnPageRequestsWhitelistRulesQueryVariables>(WebsiteOnPageRequestsWhitelistRulesDocument, options);
        }
export function useWebsiteOnPageRequestsWhitelistRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteOnPageRequestsWhitelistRulesQuery, WebsiteOnPageRequestsWhitelistRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteOnPageRequestsWhitelistRulesQuery, WebsiteOnPageRequestsWhitelistRulesQueryVariables>(WebsiteOnPageRequestsWhitelistRulesDocument, options);
        }
export type WebsiteOnPageRequestsWhitelistRulesQueryHookResult = ReturnType<typeof useWebsiteOnPageRequestsWhitelistRulesQuery>;
export type WebsiteOnPageRequestsWhitelistRulesLazyQueryHookResult = ReturnType<typeof useWebsiteOnPageRequestsWhitelistRulesLazyQuery>;
export type WebsiteOnPageRequestsWhitelistRulesSuspenseQueryHookResult = ReturnType<typeof useWebsiteOnPageRequestsWhitelistRulesSuspenseQuery>;
export type WebsiteOnPageRequestsWhitelistRulesQueryResult = Apollo.QueryResult<WebsiteOnPageRequestsWhitelistRulesQuery, WebsiteOnPageRequestsWhitelistRulesQueryVariables>;